import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayoutContactsComponent } from './payout-contacts/payout-contacts.component';
import { RouterModule, Routes } from '@angular/router';
import { NgxSelectModule } from 'ngx-select-ex'
import { SharedModule } from '../../shared/shared.module';
import { ManagePayoutContactsComponent } from './manage-payout-contacts/manage-payout-contacts.component';
// import { // Ng2TableModule, } from 'ng2-table/ng2-table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ViewPayoutContactComponent } from './view-payout-contact/view-payout-contact.component';
import { EditPayoutcontactComponent } from './edit-payoutcontact/edit-payoutcontact.component';
import { CustomerVirtualAccountComponent } from './customer-virtual-account/customer-virtual-account.component';
import { ManageCustomerVirtualAccountComponent } from './manage-customer-virtual-account/manage-customer-virtual-account.component';
import { ViewCustomerVirtualAccountComponent } from './view-customer-virtual-account/view-customer-virtual-account.component';
import { ManagePayOutTransactionsComponent } from './manage-pay-out-transactions/manage-pay-out-transactions.component';
import { ViewPayOutTransactionsComponent } from './view-pay-out-transactions/view-pay-out-transactions.component';
import { ManagePayoutLedgersComponent } from './manage-payout-ledgers/manage-payout-ledgers.component';
import { ViewPayoutledgerComponent } from './view-payoutledger/view-payoutledger.component';
import { VirtualAccountBalancesComponent } from './virtual-account-balances/virtual-account-balances.component';
import { EditCustomerVirtualAccountComponent } from './edit-customer-virtual-account/edit-customer-virtual-account.component';
import { AddBeneficiariesComponent } from './add-beneficiaries/add-beneficiaries.component';
import { ViewBeneficiarieComponent } from './view-beneficiarie/view-beneficiarie.component';
import { DeletePayoutContactsComponent } from './delete-payout-contacts/delete-payout-contacts.component';
import { DeleteCustomerVirtualAccountComponent } from './delete-customer-virtual-account/delete-customer-virtual-account.component';
import { DeleteBeneficiarieComponent } from './delete-beneficiarie/delete-beneficiarie.component';
import { PayoutbatchesComponent } from './payoutbatches/payoutbatches.component';
import { PayOutbatchdetailsComponent } from './pay-outbatchdetails/pay-outbatchdetails.component';
import { PayOutbatchviewdetailsComponent } from './pay-outbatchviewdetails/pay-outbatchviewdetails.component';
import { HomepageComponent } from './PayOutHome/homepage/homepage.component';
import { PayoutwelcomepageComponent } from './PayOutHome/payoutwelcomepage/payoutwelcomepage.component';
import { PayoutHeaderComponent } from './PayOutHome/payout-header/payout-header.component';
import { PayoutlayoutComponent } from './PayOutHome/payoutlayout/payoutlayout.component';
import { PayoutFooterComponent } from './PayOutHome/payout-footer/payout-footer.component';
import { BulkUploadFilesComponent } from './bulk-upload-files/bulk-upload-files.component';
import { PayOutBulkUploadFilesComponent } from './pay-out-bulk-upload-files/pay-out-bulk-upload-files.component';
import { PayOutBulkUploadFilesviewComponent } from './pay-out-bulk-upload-filesview/pay-out-bulk-upload-filesview.component';
import { PayOutBulkUpdateFileDetailsComponent } from './pay-out-bulk-update-file-details/pay-out-bulk-update-file-details.component';
import { ManagepayoutBeneficiaryComponent } from './managepayout-beneficiary/managepayout-beneficiary.component';
import { PayoutPostBackurlComponent } from './payout-post-backurl/payout-post-backurl.component';
import { PayOutAccountdetailsComponent } from './pay-out-accountdetails/pay-out-accountdetails.component';
import { ManagePayOutAccountdetailsComponent } from './manage-pay-out-accountdetails/manage-pay-out-accountdetails.component';
import { ViewPayoutcontactdetailsComponent } from './view-payoutAccountdetails/view-payoutcontactdetails.component';
import { PayoutReportsComponent } from './payout-reports/payout-reports.component';
import { ManagePayoutSecurityTransactionsComponent } from './manage-payout-security-transactions/manage-payout-security-transactions.component';
import { PayoutDashboardComponent } from './payout-dashboard/payout-dashboard.component';
import { PayoutSidebarComponent } from './PayOutHome/payout-sidebar/payout-sidebar.component';
import { PayoutwebhookdataComponent } from './payoutwebhookdata/payoutwebhookdata.component';
import { PayoutbalancereportComponent } from './payoutbalancereport/payoutbalancereport.component';
import { POSModule } from 'src/app/POS/pos.module';
const routes: Routes = [
  { path: 'PayoutDashboard', component:  PayoutDashboardComponent},
  { path: 'BeneficiaryList', component:  ManagepayoutBeneficiaryComponent},
  { path: 'NewPayOutContact', component:  PayoutContactsComponent},
  { path: 'ManagePayOutContact', component:  ManagePayoutContactsComponent},
  { path: 'ViewPayOutContact', component:  ViewPayoutContactComponent},
  { path: 'EditPayOutContact', component:  EditPayoutcontactComponent},
  { path: 'VirtualAccount', component:  CustomerVirtualAccountComponent},
  { path: 'ManageVirtualAccount', component:  ManageCustomerVirtualAccountComponent},
  { path: 'ViewCustomerVirtualAccount', component:  ViewCustomerVirtualAccountComponent},
  { path: 'PayOutTransactions', component:  ManagePayOutTransactionsComponent},
  { path: 'ViewPayOutTransactions', component:  ViewPayOutTransactionsComponent},
  { path: 'PayoutLedgers', component:  ManagePayoutLedgersComponent},
  { path: 'ViewPayoutLedgers', component:  ViewPayoutledgerComponent},
  { path: 'AccountBalance', component:  VirtualAccountBalancesComponent},
  { path: 'EditCustomerVirtualAccountInfo', component:  EditCustomerVirtualAccountComponent},
  { path: 'AddBeneficiaries', component:  AddBeneficiariesComponent},
  { path: 'ViewBeneficiaries', component:  ViewBeneficiarieComponent},
  { path: 'DeletePayoutContacts', component:  DeletePayoutContactsComponent},
  { path: 'DeleteCustomerVirtualAccount', component:  DeleteCustomerVirtualAccountComponent},
  { path: 'DeleteBeneficiarie', component:  DeleteBeneficiarieComponent},
  { path: 'PayOutBatches', component:  PayoutbatchesComponent},
  { path: 'PayOutBatchesView', component:  PayOutbatchdetailsComponent},
  { path: 'PayOutBatchesViewdetails', component:  PayOutbatchviewdetailsComponent},
  { path: 'PayoutHome', component:  HomepageComponent},
  { path: 'Welcompage', component:  PayoutwelcomepageComponent},
  { path: 'BulkUpload', component:  BulkUploadFilesComponent},
  { path: 'ManagePayOutBulkUploadFiles', component:  PayOutBulkUploadFilesComponent},
  { path: 'ViewPayOutBulkUploadFiles', component:  PayOutBulkUploadFilesviewComponent},
  { path: 'ViewPayOutBulkUploaddetails', component:  PayOutBulkUpdateFileDetailsComponent},
  { path: 'PayoutPostback', component:  PayoutPostBackurlComponent},
  { path: 'PayoutAccountdetails', component:  PayOutAccountdetailsComponent},
  { path: 'managePayoutAccountdetails', component:  ManagePayOutAccountdetailsComponent},
  { path: 'ViewPayoutAccountdetails', component:  ViewPayoutcontactdetailsComponent},
  { path: 'PayoutReports', component:  PayoutReportsComponent},
  { path: 'PayoutSecurityTransactions', component:  ManagePayoutSecurityTransactionsComponent},
  { path: 'Payoutwebhookdata', component:  PayoutwebhookdataComponent},
  { path: 'PayoutLedger', component:  PayoutbalancereportComponent},
];
@NgModule({
  declarations: [
    PayoutContactsComponent,
    ManagePayoutContactsComponent,
    ViewPayoutContactComponent,
    EditPayoutcontactComponent,
    CustomerVirtualAccountComponent,
    ManageCustomerVirtualAccountComponent,
    ViewCustomerVirtualAccountComponent,
    ManagePayOutTransactionsComponent,
    ViewPayOutTransactionsComponent,
    ManagePayoutLedgersComponent,
    ViewPayoutledgerComponent,
    VirtualAccountBalancesComponent,
    EditCustomerVirtualAccountComponent,
    AddBeneficiariesComponent,
    ViewBeneficiarieComponent,
    DeletePayoutContactsComponent,
    DeleteCustomerVirtualAccountComponent,
    DeleteBeneficiarieComponent,
    PayoutbatchesComponent,
    PayOutbatchdetailsComponent,
    PayOutbatchviewdetailsComponent,
    HomepageComponent,
    PayoutwelcomepageComponent,
    PayoutHeaderComponent,
    PayoutlayoutComponent,
    PayoutFooterComponent,
    BulkUploadFilesComponent,
    PayOutBulkUploadFilesComponent,
    PayOutBulkUploadFilesviewComponent,
    PayOutBulkUpdateFileDetailsComponent,
    ManagepayoutBeneficiaryComponent,
    PayoutPostBackurlComponent,
    PayOutAccountdetailsComponent,
    ManagePayOutAccountdetailsComponent,
    ViewPayoutcontactdetailsComponent,
    PayoutReportsComponent,
    ManagePayoutSecurityTransactionsComponent,
    PayoutDashboardComponent,
    PayoutSidebarComponent,
    PayoutwebhookdataComponent,
    PayoutbalancereportComponent,
  ],
  imports: [
    SharedModule,
    NgxSelectModule, 
    CommonModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    POSModule,
  ],
  exports: [
    RouterModule
]
})
export class PayModule { }
